
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface EnrichmentRunClient {
  name: string;
}

interface EnrichmentRun {
  id: string;
  client_id: string;
  status: string;
  progress_stage: string | null;
  clients: EnrichmentRunClient | null;
}

const terminalProgressStages = ['completed', 'applied', 'error', 'failed', 'cancelled'];

const fetchOngoingEnrichments = async (): Promise<EnrichmentRun[]> => {
  try {
    // Use the new optimized database function
    const { data, error } = await supabase.rpc('get_ongoing_enrichments_optimized', {
      p_limit: 20
    });

    if (error) {
      console.error('Error fetching ongoing enrichments:', error);
      return [];
    }
    
    // Transform the data to match the expected interface
    const results = (data || []).map(row => ({
      id: row.id,
      client_id: row.client_id,
      status: row.status,
      progress_stage: row.progress_stage,
      clients: { name: row.client_name }
    })) as EnrichmentRun[];
    
    return results;
  } catch (error) {
    console.error('Database query error:', error);
    return [];
  }
};

export const useGlobalEnrichmentStatus = (refetchIntervalMs: number | false = 30000) => {
  return useQuery({
    queryKey: ['globalEnrichmentStatus'],
    queryFn: fetchOngoingEnrichments,
    refetchInterval: refetchIntervalMs,
    select: (data) => data.filter(run => run.clients),
    staleTime: 30000, // Cache for 30 seconds
    gcTime: 120000, // Keep in cache for 2 minutes
    refetchOnWindowFocus: false, // Prevent unnecessary refetches
  });
};
